import includes from 'lodash/includes';
import paymentTypeConstants from '../../constants/paymentTypeConstants';

function isSavedPaymentCard(paymentType) {
  return includes(paymentType, paymentTypeConstants.SAVED_PAYMENT_CARD);
}

export default isSavedPaymentCard;
